import Config from "../../../../../shared/src/ranj/app/config/Config";
import MockApi from "../../../../../shared/src/ranj/equalture/platform/MockAPI";
import MockPlatformAPIService from "../../../../../shared/src/ranj/equalture/platform/MockPlatformAPIService";
import PlatformAPIEventType from "../../../../../shared/src/ranj/equalture/platform/PlatformAPIEventType";
import ProgressValue from "../../../../../shared/src/ranj/equalture/platform/ProgressValue";
import ScenarioState from "../core/model/ScenarioState";
import NGTConfigKey from "../ngt/base/NGTConfigKey";

export default class CollaborationPlatformMockAPIService extends MockPlatformAPIService {
    constructor(saveModel, config, dispatcher) {
        super(saveModel, config, dispatcher)
    }

    _createMockApi(environment) {
        const scenarios = this._config.getValue(NGTConfigKey.SCENARIOS);
        const globalAppId = this._config.getValue(Config.APPID);
        return new CollaborationMockAPI(globalAppId, environment, scenarios);
    }
}

class CollaborationMockAPI extends MockApi {
    constructor(globalAppId, environment, scenarios) {
        super(environment);
        this._globalAppId = globalAppId;
        this._scenarios = scenarios;
        this._availableEpisodeIds = this._loadAvailableEpisodeIds() ?? scenarios.map(s => s.scenarioID);
    }

    async getGlobalConfigurationAsync() {
        const configuration = await super.getGlobalConfigurationAsync();
        configuration.episodes = this._loadEpisodesStates();
        return configuration;
    }

    sendEventAsync(eventType, payload) {
        const episodeStates = this._loadEpisodesStates();
        // NB: handle expected behaviour of platform when a scenario start/ends
        switch (eventType) {
            case PlatformAPIEventType.PROGRESS:
                const episodeState = episodeStates.find(s => s.id === payload.appId);
                episodeState.state = payload.progress_value == ProgressValue.COMPLETED 
                    ? ScenarioState.STATE_FINISHED
                    : ScenarioState.STATE_STARTED;
                this._saveEpisodesStates(episodeStates);
                break;
        }

        return super.sendEventAsync(eventType, payload);
    }

    /**
     * Debug method used to set a list of episode ids that are available. 
     * After calling this method, it is recommended to refresh the webpage to see its effect.
     * @param {string[]} episodeIds 
     */
    setMockEpisodesList(episodeIds) {
        this._availableEpisodeIds = episodeIds;
        this._saveAvailableEpisodeIds(episodeIds);
    }

    _saveAvailableEpisodeIds(episodeIds) {
        const str = !episodeIds || episodeIds.length <=0 ? "" : JSON.stringify(episodeIds);
        window.localStorage.setItem(`${this._globalAppId}.availableEpisodeIds`, str);
    }

    _loadAvailableEpisodeIds() {
        const str = window.localStorage.getItem(`${this._globalAppId}.availableEpisodeIds`);
        if(!str) {
            return null;
        }
        return JSON.parse(str);
    }

    _saveEpisodesStates(episodeStates) {
        const str = JSON.stringify(episodeStates);
        window.localStorage.setItem(`${this._globalAppId}.episodeStates`, str);
    }

    /**
     * 
     * @returns {{ id: string, state: string}[]}
     */
    _loadEpisodesStates() {
        const str = window.localStorage.getItem(`${this._globalAppId}.episodeStates`);
        let states;
        if (!str) {
            states = this._scenarios.map(scenario => ({
                id: scenario.scenarioID,
                state: ScenarioState.STATE_AVAILABLE,
            }));
        } else {
            states = JSON.parse(str);
        }

        // NB: if any - filter states based on mock available episode ids
        if(!!this._availableEpisodeIds && this._availableEpisodeIds.length > 0) {
            states = states.filter(s => this._availableEpisodeIds.includes(s.id));
        }

        return states;
    }
}